import { render, staticRenderFns } from "./transport-details.vue?vue&type=template&id=638bcbb8"
import script from "./transport-details.vue?vue&type=script&lang=js"
export * from "./transport-details.vue?vue&type=script&lang=js"
import style0 from "./transport-details.vue?vue&type=style&index=0&id=638bcbb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports